import React, {Component} from 'react';
import Swal from 'sweetalert2';
import 'react-table/react-table.css';
import {Button, Col, Modal, ModalBody, ModalHeader} from "reactstrap";
import {hasUserRight, showAxiosError} from "../../helper/helper";
import {getCurrentUser, request} from "../../helper/APIUtils";
import Table from "../../components/Table/Table";
import NavBarKS from "../../components/NavBarKS";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import MiniButton from "../../components/MiniButton";
import SweetAlertExt from "../../components/SweetAlertExt";
import StickButton from "../../components/StickButton";
import ReadFromExcel from "../voucher/component/ReadFromExcel";
import Alert from "react-s-alert";
import XLSX from "xlsx";
import moment from "moment";
import {EntegratorIdentifiers, ExternalCustomerMainType, UserRightsEnum} from "../../helper/enums";
import {ACCESS_TOKEN, EntegratorConf, VirtualHost} from "../../constants";

class ExternalCustomerList extends Component {

	constructor(props) {
		super(props);
		this.state = {
			externalCustomers: [],
			selectedExternalCustomers: [],
			searchQuery: undefined,
			pages: null,
			loading: false,
			manual: false,
			total: 0,
			page: 0,
			size: 10,
			deleteModal: false,
			searching: false,
			selection: [],
			selectedAll: false,
			deleteAllAlert:null,
			processing: false
		};
		this.fetchData = this.fetchData.bind(this);
		this.handleCreate = this.handleCreate.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.exportToExcel = this.exportToExcel.bind(this);
		this.fetchAllExternalCustomer = this.fetchAllExternalCustomer.bind(this);
		this.exportToExcelAll = this.exportToExcelAll.bind(this);
	}

	componentDidMount() {
		const propName = this.props.name;
		let pageDefiner;
		if (propName === 'suppliers') {
			pageDefiner = 's';
		} else if (propName === 'externalCustomer') {
			pageDefiner = 'e';
		} else {
			// error
		}
		this.setState({pageDefiner});
	}


	async fetchData(accessor, direction, page, size) {
		let self = this;
		let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=recordId,desc';
		let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
		let target = this.props.name;
		let params = {
			url: `/externalCustomer/fetch?page=${page}&size=${size}${sortStr}${searchQuery}&target=${target}`,
			method: "get",
		};


		self.setState({loading: true, searching: true, manual: self.manual === true ? false : self.manual});
		await request(params)
			.then(function (response) {
				self.setState({
					page: page,
					size: size,
					total: response.data.totalElements,
					externalCustomers: response.data.content,
					loading: false,
					searching: false
				});
			}).catch(function (error) {
			self.setState({loading: false, searching: false});
			showAxiosError(error);
		});

	}

	handleEdit(item) {
		this.props.history.push(`/createEditExternalCustomer/${this.props.name}/${item.recordId}`);
	}

	handleCreate() {
		this.props.history.push({ pathname: `/createEditExternalCustomer/${this.props.name}/0`});
	}

	handleDelete(item) {
		let self = this;
		let params = {
			url: `/externalCustomer/delete/${item.recordId}`,
			method: 'post'
		};
		request(params)
			.then(function (response) {
				self.setState({loading: false, alert: null, selection: []});
				Swal({
					title: "İşlem Başarılı",
					text: "Silme işlemi başarıyla gerçekleştirildi.",
					type: "success",
					confirmButtonText: 'Tamam'
				}).then((result) => {
					self.fetchData(self.state.accessor, self.state.direction, 0, self.state.size);
				})
			}).catch(function (error) {
			showAxiosError(error);
			self.setState({loading: false, alert: null})
		});
	}

	openDeletConfirmModal(item) {
		this.setState({
			selectedRow: item,
			deleteModal: true
		})
	}

	handleSearch(searchQuery) {
		this.setState({
			searchQuery,
			searching: true
		}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
	}

	toggleCheckboxChange(e, row, id) {
		let self = this;
		let checked = e.target.checked;
		let items = self.state.externalCustomers;
		let selection = self.state.selection;
		if (row === "all") {
			let selection = [];
			if (checked) {
				items.forEach(item => {
					selection.push(item[id]);
				});
			}
			self.setState({selection: selection, selectedAll: checked});
		} else {
			let index = selection.indexOf(row[id]);
			if (index >= 0) {
				selection = [
					...selection.slice(0, index),
					...selection.slice(index + 1)
				];
			} else {
				selection.push(row[id]);
			}
			self.setState({
				selection: selection,
				selectedAll: ((selection.length > 0) ? (selection.length === self.state.externalCustomers.length) : false)
			});
		}
	}

	isSelected(id) {
		return (this.state.selection.indexOf(id) !== -1);
	}

	deleteSelected() {
		let self = this;
		self.setState({deleteLoading: true});
		let selection = self.state.selection;
		let params = {
			url: `/externalCustomer/deleteMultiple`,
			method: 'post',
			data: selection
		};
		request(params)
			.then(function (response) {
				self.setState({loading: false, manual: true, deleteAllAlert:null,selectedAll:false, deleteLoading:false, selection: []});
				Alert.success("Silme işlemi başarıyla gerçekleştirildi.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 2000
				});
			}).catch(function (error) {
			self.setState({loading: false, manual: true, deleteAllAlert:null, deleteLoading:false, selection: []});
			showAxiosError(error);
		});
	}

	async fetchAllExternalCustomer() {
		let self = this;
		let params = {
			url: `/externalCustomer/fetchAllExternalCustomer`,
			method: "get",
		};
		let allExternalCustomers;
		self.setState({processing: true})
		await request(params)
			.then(function (response) {
				allExternalCustomers = response.data;
				self.setState({processing: false})
			}).catch(function (error) {
				self.setState({processing: false, searching: false});
				showAxiosError(error);
			});

		return allExternalCustomers;
	}

	async exportToExcel(e) {
		const {selection} = this.state;
		let self = this;

		let params = {
			url: `/externalCustomer/fetchSelected`,
			method: "post",
			data: selection,
		};

		await request(params)
			.then(function (response) {
				self.setState({
					selectedExternalCustomers: response.data
				});
			}).catch(function (error) {
				self.setState({loading: false, searching: false});
				showAxiosError(error);
			});

		let data = [];
		 data.push({
			/* vkn_tckn: "VKN/TCKN_(Zorunlu)",
			 formatted_name: "Unvan_(Vkn_için_zorunlu)",
			 given_name: "Adı_(Tckn_için_zorunlu)",*/
			 vkn_tckn: "VKN/TCKN",
			 formatted_name: "Unvan",
			 given_name: "Ad",
			 middle_name: "Orta_Adı",
			 /*family_name: "Soyadı_(Tckn_için_zorunlu)",*/
			 family_name: "Soyad",
			 commerce_chamber: "Ticaret_Odası",
			 city: "Vergi_Dairesi_Şehir",
			 tax_office: "Vergi_Dairesi",
			 mersis_number: "Mersis_No",
			 trade_registration_number: "Ticaret_Sicil_No",
			 /*customer_type: "Müşteri_Tipi_(Zorunlu)",*/
			 customer_type: "Müşteri_Tipi",
			 initial_balance: "Başlangıç_Bakiyesi",
			 customer_risk_limit: "Müşteri_Risk_Limiti",
			 /*address_name: "Adres_Adı_(Zorunlu)",*/
			 address_name: "Adres_Adı",
			 contact_person: "Yetkili_Kişi",
			/* country_name: "Ülke_(Zorunlu)",
			 city_name: "Şehir_(Zorunlu)",
			 city_subdivision_name: "İlçe_(Zorunlu)",*/
			 country_name: "Ülke",
			 city_name: "Şehir",
			 city_subdivision_name: "İlçe",
			 web_site: "Web_Sitesi",
			 email: "E_Posta",
			 telephone: "Telefon",
			 fax: "Faks",
			 postal_address_region: "Mahalle/Cadde",
			 building_name: "Bina_Adı",
			 building_no: "Bina_No",
			 postal_address_room: "Daire_No",
			 postal_zone: "Posta_Kodu",
			 bank_name: "Banka_Adı",
			 iban: "IBAN",
			 is_foreign_customer: "Yabancı_Müşteri"
		 });

		this.state.selectedExternalCustomers.map(line => {
			let row = {
				vkn_tckn: (line["vknTckn"] !== "" && line["vknTckn"] !== null ? line["vknTckn"] : "Boş Olamaz"),
				formatted_name: line["formattedName"] ? line["formattedName"] : "",
				given_name: line["givenName"] ? line["givenName"] : "",
				middle_name: line["middleName"] ? line["middleName"] : "",
				family_name: line["familyName"] ? line["familyName"] : "",
				commerce_chamber: line["commerceChamber"] ? line["commerceChamber"] : "",
				city: line["city"] ? line["city"] : "",
				tax_office: line["taxOffice"] ? line["taxOffice"] : "",
				mersis_number: line["mersisNumber"] ? line["mersisNumber"] : "",
				trade_registration_number: line["tradeRegistrationNumber"] ? line["tradeRegistrationNumber"] : "",
				customer_type: line["customerType"] ? line["customerType"] === 1 ? "Satıcı" : line["customerType"] === 2 ? "Alıcı" : "Her İkisi" : "",
				initial_balance: line["initialBalance"] ? line["initialBalance"] : "",
				customer_risk_limit: line["customerRiskLimit"] ? line["customerRiskLimit"] : "",

				address_name: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].addressName ? line["externalCustomerAddressList"][0].addressName : "",
				contact_person: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].contactPerson ? line["externalCustomerAddressList"][0].contactPerson : "",
				country_name: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].countryName ? line["externalCustomerAddressList"][0].countryName : "",
				city_name: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].cityName ? line["externalCustomerAddressList"][0].cityName : "",
				city_subdivision_name: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].citySubdivisionName ? line["externalCustomerAddressList"][0].citySubdivisionName : "",
				web_site: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].webSite ? line["externalCustomerAddressList"][0].webSite : "",
				email: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].email ? line["externalCustomerAddressList"][0].email : "",
				telephone: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].telephone ? line["externalCustomerAddressList"][0].telephone : "",
				fax: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].fax ? line["externalCustomerAddressList"][0].fax : "",
				postal_address_region: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].streetName ? line["externalCustomerAddressList"][0].streetName : "",
				building_name: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].buildingName ? line["externalCustomerAddressList"][0].buildingName : "",
				building_no: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].buildingNo ? line["externalCustomerAddressList"][0].buildingNo : "",
				postal_address_room: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].postalAddressRoom ? line["externalCustomerAddressList"][0].postalAddressRoom : "",
				postal_zone: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].postalZone ? line["externalCustomerAddressList"][0].postalZone : "",

				bank_name: line["externalCustomerBankList"][0] && line["externalCustomerBankList"][0].bankName ? line["externalCustomerBankList"][0].bankName : "",
				iban: line["externalCustomerBankList"][0] && line["externalCustomerBankList"][0].iban ? line["externalCustomerBankList"][0].iban : "",
				is_foreign_customer: line["externalCustomerMainType"] === "FOREIGN" ? "EVET" : "HAYIR"
				/*is_foreign_customer: line["isForeignCustomer"] === true ? "EVET" : "HAYIR",*/

			}
			data.push(row);
		})

		/* make the worksheet */
		let ws = XLSX.utils.json_to_sheet(data, {skipHeader: true});

		/* add to workbook */
		let wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Şablon");

		/* generate an XLSX file */
		XLSX.writeFile(wb, "Müşteri Listesi" + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx");
	}

	async exportToExcelAll(e) {
		let self = this;
		let allRecords = await self.fetchAllExternalCustomer();

		let data = [];
		data.push({
			/* vkn_tckn: "VKN/TCKN_(Zorunlu)",
			 formatted_name: "Unvan_(Vkn_için_zorunlu)",
			 given_name: "Adı_(Tckn_için_zorunlu)",*/
			vkn_tckn: "VKN/TCKN",
			formatted_name: "Unvan",
			given_name: "Ad",
			middle_name: "Orta_Adı",
			/*family_name: "Soyadı_(Tckn_için_zorunlu)",*/
			family_name: "Soyad",
			commerce_chamber: "Ticaret_Odası",
			city: "Vergi_Dairesi_Şehir",
			tax_office: "Vergi_Dairesi",
			mersis_number: "Mersis_No",
			trade_registration_number: "Ticaret_Sicil_No",
			/*customer_type: "Müşteri_Tipi_(Zorunlu)",*/
			customer_type: "Müşteri_Tipi",
			initial_balance: "Başlangıç_Bakiyesi",
			customer_risk_limit: "Müşteri_Risk_Limiti",
			/*address_name: "Adres_Adı_(Zorunlu)",*/
			address_name: "Adres_Adı",
			contact_person: "Yetkili_Kişi",
			/* country_name: "Ülke_(Zorunlu)",
			 city_name: "Şehir_(Zorunlu)",
			 city_subdivision_name: "İlçe_(Zorunlu)",*/
			country_name: "Ülke",
			city_name: "Şehir",
			city_subdivision_name: "İlçe",
			web_site: "Web_Sitesi",
			email: "E_Posta",
			telephone: "Telefon",
			fax: "Faks",
			postal_address_region: "Mahalle/Cadde",
			building_name: "Bina_Adı",
			building_no: "Bina_No",
			postal_address_room: "Daire_No",
			postal_zone: "Posta_Kodu",
			bank_name: "Banka_Adı",
			iban: "IBAN",
			is_foreign_customer: "Yabancı_Müşteri"
		});

		allRecords.map(line => {
			let row = {
				vkn_tckn: (line["vknTckn"] !== "" && line["vknTckn"] !== null ? line["vknTckn"] : "Boş Olamaz"),
				formatted_name: line["formattedName"] ? line["formattedName"] : "",
				given_name: line["givenName"] ? line["givenName"] : "",
				middle_name: line["middleName"] ? line["middleName"] : "",
				family_name: line["familyName"] ? line["familyName"] : "",
				commerce_chamber: line["commerceChamber"] ? line["commerceChamber"] : "",
				city: line["city"] ? line["city"] : "",
				tax_office: line["taxOffice"] ? line["taxOffice"] : "",
				mersis_number: line["mersisNumber"] ? line["mersisNumber"] : "",
				trade_registration_number: line["tradeRegistrationNumber"] ? line["tradeRegistrationNumber"] : "",
				customer_type: line["customerType"] ? line["customerType"] === 1 ? "Satıcı" : line["customerType"] === 2 ? "Alıcı" : "Her İkisi" : "",
				initial_balance: line["initialBalance"] ? line["initialBalance"] : "",
				customer_risk_limit: line["customerRiskLimit"] ? line["customerRiskLimit"] : "",

				address_name: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].addressName ? line["externalCustomerAddressList"][0].addressName : "",
				contact_person: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].contactPerson ? line["externalCustomerAddressList"][0].contactPerson : "",
				country_name: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].countryName ? line["externalCustomerAddressList"][0].countryName : "",
				city_name: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].cityName ? line["externalCustomerAddressList"][0].cityName : "",
				city_subdivision_name: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].citySubdivisionName ? line["externalCustomerAddressList"][0].citySubdivisionName : "",
				web_site: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].webSite ? line["externalCustomerAddressList"][0].webSite : "",
				email: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].email ? line["externalCustomerAddressList"][0].email : "",
				telephone: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].telephone ? line["externalCustomerAddressList"][0].telephone : "",
				fax: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].fax ? line["externalCustomerAddressList"][0].fax : "",
				postal_address_region: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].streetName ? line["externalCustomerAddressList"][0].streetName : "",
				building_name: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].buildingName ? line["externalCustomerAddressList"][0].buildingName : "",
				building_no: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].buildingNo ? line["externalCustomerAddressList"][0].buildingNo : "",
				postal_address_room: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].postalAddressRoom ? line["externalCustomerAddressList"][0].postalAddressRoom : "",
				postal_zone: line["externalCustomerAddressList"][0] && line["externalCustomerAddressList"][0].postalZone ? line["externalCustomerAddressList"][0].postalZone : "",

				bank_name: line["externalCustomerBankList"][0] && line["externalCustomerBankList"][0].bankName ? line["externalCustomerBankList"][0].bankName : "",
				iban: line["externalCustomerBankList"][0] && line["externalCustomerBankList"][0].iban ? line["externalCustomerBankList"][0].iban : "",
				is_foreign_customer: line["externalCustomerMainType"] === "FOREIGN" ? "EVET" : "HAYIR"
				/*is_foreign_customer: line["isForeignCustomer"] === true ? "EVET" : "HAYIR",*/

			}
			data.push(row);
		})

		/* make the worksheet */
		let ws = XLSX.utils.json_to_sheet(data, {skipHeader: true});

		/* add to workbook */
		let wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Şablon");

		/* generate an XLSX file */
		XLSX.writeFile(wb, "Müşteri Listesi" + moment().format("YYYY_mm_dd_HH_mm_ss") + ".xlsx");
	}

	render() {
		const {externalCustomers, pages, loading} = this.state;
		const source = VirtualHost.conf.resourcePrefix;

		const columns = [
			{
				Header: (<input type="checkbox" checked={this.state.selectedAll}
								onChange={(e) => this.toggleCheckboxChange(e, "all", "recordId")}/>),
				accessor: "recordId",
				selectType: "checkbox",
				sortable: false,
				Cell: (row, index) => (<input type="checkbox" checked={this.isSelected(row.recordId)}
											  onChange={(e) => this.toggleCheckboxChange(e, row, "recordId", index)}/>)
			},
			{
				Header: "VKN/TCKN",
				title: "VKN/TCKN",
				accessor: "vknTckn",
				Cell: (row, index) => (row.vknTckn)
			},
			{
				Header: "Unvan",
				title: "Unvan",
				accessor: "formattedName",
			},
			{
				Header: "Ad",
				title: "Ad",
				accessor: "givenName"
			},
			{
				Header: "Orta Ad",
				title: "Orta Ad",
				accessor: "middleName"
			},
			{
				Header: "Soyad",
				title: "Soyad",
				accessor: "familyName"
			},
			{
				Header: "Müşteri Tipi",
				title: "Müşteri Tipi",
				accessor: "externalCustomerMainType",
				Cell: (row, index) => (row.externalCustomerMainType ?
					((row.externalCustomerMainType === ExternalCustomerMainType.Normal) ? "T.C. Vatandaşı" :
						(row.externalCustomerMainType === ExternalCustomerMainType.Foreign) ?  'Yabancı' :
							(row.externalCustomerMainType === ExternalCustomerMainType.DespatchMixed) ?  'E-İrsaliye Muhtelif' : '')
				:
						"T.C. Vatandaşı"
				)
			},
			{
				Header: "İşlemler",
				title: "İşlemler",
				Cell: row => (
					<div>
						<button type="button"
								onClick={() => this.handleEdit(row)}
								data-toggle="tooltip" data-placement="bottom" title="Düzenle"
								style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}} rel="tooltip"
								disabled={!hasUserRight(UserRightsEnum.settings.externalCustomer.update,this.props.currentUser)}
								className="Btn  btn-icon">
							<i className="BtnIcon far fa-edit "/>
						</button>
						<button type="button"
								onClick={e => {
									this.setState({
										alert: (
											<SweetAlertExt showCancel warning
														   confirmBtnText="Evet"
														   cancelBtnText="Hayır"
														   confirmBtnBsStyle="danger"
														   cancelBtnBsStyle="default"
														   title="Emin misiniz?"
														   onConfirm={() => this.handleDelete(row)}
														   onCancel={() => this.setState({alert: null})}
														   loading={this.state.deleteLoading}
											>
												{row.formattedName !== null ? (row.formattedName + " silinecek.") : (row.givenName + " " + row.familyName + " silinecek.")}
											</SweetAlertExt>
										)
									});
								}}
								data-toggle="tooltip" data-placement="bottom" title="Sil"
								disabled={!hasUserRight(UserRightsEnum.settings.externalCustomer.delete,this.props.currentUser)}
								style={{background: 'linear-gradient(rgb(236 92 92 / 57%), rgb(255 66 66))'}}
								rel="tooltip" className="Btn  btn-icon">
							<i className="BtnIcon far fa-trash-alt"/>
						</button>
					</div>
				)
			}
		];

		const fields = [
			{
				label: "VKN/TCKN",
				accessor: "vknTckn",
				type: "numericText",
				operator: "=",
			},
			{
				label: "Ad",
				accessor: "givenName",
				type: "text",
				operator: "=",
			},
			{
				label: "Soyad",
				accessor: "familyName",
				type: "text",
				operator: "=",
			},
			{
				label: "Unvan",
				accessor: "formattedName",
				type: "text",
				operator: "=",
			}
		];
		return (
			<div className="row baseBackground externalCustomerListContainer">

				{this.state.alert}
				{this.state.deleteAllAlert}

				<NavBarKS name='externalCustomerList'>
					<StickButton position="leftSide"
								 onClick={() => this.handleCreate()}
								 label="Müşteri Oluştur"
								 title="Müşteri Oluştur"
								 className="stickButton plus-circle"
								 disabled={!hasUserRight(UserRightsEnum.settings.externalCustomer.create,this.props.currentUser)}
								 icon="plus-circle"/>

					<StickButton position="leftSide"
								 title="Excel'den Kaydet"
								 label="Excel'den Kaydet"
								 className="stickButton excel"
								 disabled={!hasUserRight(UserRightsEnum.settings.externalCustomer.create,this.props.currentUser)}
								 icon="excel"
								 onClick={(e) => this.setState({showExcelModal: true})}/>

					<StickButton position="leftSide"
								 onClick={this.exportToExcel}
								 label="Excel'e Aktar"
								 title="Excel'e Aktar"
								 className="stickButton excel"
								 icon="excel"
								 disabled={(this.state.selection.length <= 0) || (this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4) && ["smart", "kolaysoft", 'mbtfatura'].includes(VirtualHost.conf.resourcePrefix)}/>

					<StickButton position="leftSide"
								  onClick={this.exportToExcelAll}
								  label={this.state.processing ? "Oluşturuluyor..." : "Tümünü Excel'e Aktar"}
								  title="Tümünü Excel'e Aktar"
								  className="stickButton excel"
								  icon="excel"
								  disabled={this.state.processing || ((["smart", "kolaysoft", "mbtfatura"].includes(VirtualHost.conf.resourcePrefix)) &&
						(this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4) )}/>

					<StickButton position="leftSide"
								 title="Seçilileri Sil"
								 label="Seçilileri Sil"
								 className="stickButton trash"
								 onClick={(e) =>
									 this.setState({
										 deleteAllAlert: (
											 <SweetAlertExt showCancel warning
															confirmBtnText="Evet"
															cancelBtnText="Hayır"
															confirmBtnBsStyle="danger"
															cancelBtnBsStyle="default"
															title="Emin misiniz?"
															onConfirm={() => this.deleteSelected()}
															onCancel={() => this.setState({deleteAllAlert: null})}
															loading={this.state.deleteLoading}
											 >
												Seçilenler silinecektir. Emin misiniz?
											 </SweetAlertExt>
										 )
									 })
								 }
								 icon='trash'
								 disabled={this.state.selection.length <= 0 || !hasUserRight(UserRightsEnum.settings.externalCustomer.delete,this.props.currentUser)}/>
				</NavBarKS>

				<div className="col-sm-12 satirBasi">
					<div className="card-header  ">
						<h4 className="card-title">{this.props.name === 'suppliers' ? 'Tedarikçi Listesi' : 'Müşteri Listesi'}</h4>
					</div>
					<div className="card-body row">
						<Col xs='12' style={{marginTop: '10px', marginBottom: '10px'}}>
							<DetailedSearch fields={fields}
											loading={this.state.searching}
											onSearch={this.handleSearch}/>
						</Col>

						<Table
							columns={columns}
							content={externalCustomers}
							total={this.state.total}
							loading={this.state.loading}
							page={this.state.page}
							manual={this.state.manual}
							size={this.state.size}
							options={["5", "10", "20", "50", "100"]}
							fetchData={this.fetchData}
						/>
					</div>
				</div>

				<Modal isOpen={this.state.deleteModal}>
					<ModalHeader toggle={this.toggle}>Emin Misiniz ?</ModalHeader>
					<ModalBody>
						<div className="col-sm-12 row">
							<div className="col-sm-2">
								<Button color="primary"
										onClick={() => this.setState({deleteModal: false}, this.handleDelete(this.state.selectedRow))}
										style={{padding: '11px 45px 11px 20px'}}
										className="TekBtn kaydet ">Onayla</Button></div>
							<div className="col-sm-8"></div>
							<div className="col-sm-2">
								<Button color="secondary" onClick={() => this.setState({
									deleteModal: false
								})} className="TekBtn vazgec "
										style={{
											background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
											padding: '11px 45px 11px 20px'
										}}>İptal</Button>
							</div>
						</div>
					</ModalBody>
				</Modal>

				{this.state.showExcelModal &&
				<ReadFromExcel
					type="externalCustomerList"
					profileId={this.props.profileId}
					toggleModal={(flag, manual) => this.setState({showExcelModal: flag, manual: manual})}
					modal={this.state.showExcelModal}/>
				}
			</div>
		);
	}
}

export default ExternalCustomerList;